import script from "./ListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ListComponent.vue?vue&type=script&setup=true&lang=js"

import "./ListComponent.vue?vue&type=style&index=0&id=d1dfc4ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1dfc4ae"]])

export default __exports__